export type PixelCheckStatus = 'completed' | 'inconclusive' | 'skipped' | 'declined';

interface VerdictInput {
  metadataAiDetected: boolean;
  pixelAiDetected: boolean;
  isInvalid: boolean;
  pixelCheckStatus: PixelCheckStatus;
}

interface VerdictResult {
  verdict: 'pass' | 'fail';
  pixelCheckInconclusive: boolean;
  metadataOnly: boolean;
}

export function determineVerdict(input: VerdictInput): VerdictResult {
  const { metadataAiDetected, pixelAiDetected, pixelCheckStatus } = input;

  // Only AI detection blocks uploads — unsigned/unverified files are allowed
  if (metadataAiDetected || pixelAiDetected) {
    return { verdict: 'fail', pixelCheckInconclusive: false, metadataOnly: false };
  }

  const pixelCheckInconclusive = pixelCheckStatus === 'inconclusive' || pixelCheckStatus === 'declined';
  const metadataOnly = pixelCheckStatus === 'skipped';

  return { verdict: 'pass', pixelCheckInconclusive, metadataOnly };
}
